import {Component, EventEmitter, Inject, NgZone, OnInit, Output} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {Law} from "../../../models/laws";
import {Message} from "../../../models/message";
import {Service} from "../../../models/service";
import {LawControllerService} from "../../../services/laws-controller/law-controller.service";
import {MessageControllerService} from "../../../services/message-controller/message-controller.service";
import {ServiceControllerService} from "../../../services/service-controller/service-controller.service";
import {BaseError} from "../base-error";

@Component({
    selector: "law-detail",
    templateUrl: "./law-detail.component.html",
})

export class LawsDetailComponent implements OnInit {
    public lawId: string;
    public serviceId: string;
    public service: Service = new Service();
    public law: Law;

    constructor(private lawControllerService: LawControllerService,
                private route: ActivatedRoute, private router: Router) {
    }

    public ngOnInit() {
        this.initMessage();
    }

    public initMessage() {
        this.route.params.subscribe((params) => {
            this.serviceId = params.serviceId;
            this.lawId = params.lawId;
            if (this.lawId && this.lawId !== "new") {
                this.lawControllerService.getLaw(this.lawId).subscribe(
                    (data) => this.uploadData(data),
                );
            } else {
                this.uploadData(new Law());
            }
        });

    }

    public uploadData(law: Law) {
        this.law = law;
    }

    public lawsWindowSubmitted(event) {
        if (event.create === true && event.message) {
            this.router.navigate(["/services/" + this.serviceId + "/lawstable"]);
        } else if (event.save === true) {
            this.initMessage();
            this.router.navigate(["/services/" + this.serviceId + "/lawstable"]);
        }
        if (event.delete || event.cancel) {
            this.router.navigate(["/services/" + this.serviceId + "/lawstable"]);
        }
    }
}
